import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-obsidian text-bone">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-bone/10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <span className="bg-white rounded-full p-2.5 inline-flex items-center justify-center">
              <img src="/logo.png" alt="SNP Plastech logo" className="h-11 w-11 object-contain" />
            </span>
            <span className="font-display font-semibold text-3xl tracking-tight">SNP PLASTECH</span>
          </div>
          <p className="text-bone/60 max-w-sm text-sm leading-relaxed">
            Mfg. HM-HDPE Carboys, Drums, Mausers, Full Open Top Jars, Jerrycans &amp; more — bottles, containers and industrial packs, from resin to retail-ready.
          </p>
        </div>
        <div className="lg:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-bone/40 mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/products" data-testid="footer-link-products" className="text-bone/70 hover:text-emerald transition-colors duration-200">Products</Link></li>
            <li><Link to="/#about" data-testid="footer-link-about" className="text-bone/70 hover:text-emerald transition-colors duration-200">About</Link></li>
            <li><Link to="/#industries" data-testid="footer-link-industries" className="text-bone/70 hover:text-emerald transition-colors duration-200">Industries</Link></li>
            <li><Link to="/#quality" data-testid="footer-link-quality" className="text-bone/70 hover:text-emerald transition-colors duration-200">Quality</Link></li>
            <li><Link to="/blog" data-testid="footer-link-blog" className="text-bone/70 hover:text-emerald transition-colors duration-200">Journal</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-bone/40 mb-5">Range</p>
          <ul className="space-y-3 text-sm text-bone/70">
            <li>HDPE Bottles</li>
            <li>Wide Mouth Containers</li>
            <li>Narrow Mouth Mausers</li>
            <li>Full Open Top Drums</li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-bone/40 mb-5">Contact</p>
          <ul className="space-y-3 text-sm text-bone/70">
            <li>Works: G.T. Road, Greater Noida, Distt. Gautam Buddha Nagar (U.P.) – 201306</li>
            <li>H.O.: KH-266, Kavi Nagar, Ghaziabad (U.P.) – 201002</li>
            <li>+91 98110 92858 · +91 79823 38552</li>
            <li>info@snpplastech.com</li>
          </ul>
          <Link
            to="/contact"
            data-testid="footer-enquiry-cta"
            className="group inline-flex items-center gap-2 mt-6 text-sm font-medium text-emerald hover:text-bone transition-colors duration-200"
          >
            Start an enquiry
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
          </Link>
          <a
            href="/snp-plastech-catalogue.pdf"
            download
            data-testid="footer-catalogue-link"
            className="block mt-3 text-sm font-medium text-bone/60 hover:text-emerald transition-colors duration-200"
          >
            Download catalogue (PDF)
          </a>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-bone/40 tracking-wide">
        <span>© {new Date().getFullYear()} SNP Plastech. All rights reserved.</span>
        <span>Precision in every polymer.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
